import { render, staticRenderFns } from "./MeasurementReminderList.vue?vue&type=template&id=44d03bee&scoped=true"
import script from "./MeasurementReminderList.vue?vue&type=script&lang=js"
export * from "./MeasurementReminderList.vue?vue&type=script&lang=js"
import style0 from "./MeasurementReminderList.vue?vue&type=style&index=0&id=44d03bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d03bee",
  null
  
)

export default component.exports